<template>
    <div>

        <section class="feature-section mt-20">
            <div class="container">
                <div class="row">
                    <div class="col-md-5 text-left">
                      <h2>Your Data, Your Workflow <br /> Just Better</h2>
                      <p>Ingest from event streams and historical batch loads via your current local workflow or production CICD/Orchestration tooling.</p>
                      <p>Deploy Skippr's Docker container to your cloud platform, your data never leaves your private network.</p>
                    </div>
                    <div class="col-md-7">

                        <div class="row mb-30">
                            <div v-for="(model, index) in plugins" v-bind:key="index" class="col-xs-4 col-md-3">
                                <div class="contact-box" v-on:click="clickEvent(model)">
                                    <div class="row">
                                        <div class="col-4 mb-30">
                                            <div class="text-center">

                                                <img v-bind:src="'images/logos/' + lowerCase(model.name) + '.png'"
                                                     class="img-circle m-t-xs img-fluid"
                                                     max-width="100px"
                                                     max-height="100px"
                                                     style="
                                                max-width: 100px;
                                                max-height: 100px;
                                                padding: 12px;
                                                vertical-align: middle;
                                                background-color: #fff;
                                                box-shadow: 0 6px 20px -5px rgba(50,50,93,0.25);
                                                cursor: pointer;"
                                                />
                                                <div class="m-t-xs font-bold">{{ model.name }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

<!--                        <p class="text-center">-->
<!--                            <router-link to="/integrations/destinations" class="btn btn-primary btn-sm">View all Destinations</router-link>-->
<!--                        </p>-->
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>

    import {lowerCase} from "lodash";

    export default {
        name: 'DestinationIntegrations',
        props: {

            plugins: {
                type: Array,
                default() {
                    return [
                        {name: 'AWS'},
                        {name: 'Github'},
                        {name: 'Airflow'},
                        {name: 'Docker'},
                        {name: 'DBT'},
                        {name: 'Terraform'},
                        {name: 'Soda'},
                        {name: 'Jupyter'},
                    ];
                },
            },

        },
        methods: {
          lowerCase,
            clickEvent(name) {
              this.$gtag.event('click', {
                event_category: 'ecosystem',
                event_label: name,
              })
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
